<template>

<div>
      <v-app-bar
        elevation="0"
        height="300"
        src="@/assets/bg.jpg"
      >
          <v-spacer></v-spacer>
          <v-card tile>
            <v-row>
              <v-col cols="6">
                <v-img alt="Lexicon Syariah Logo" class="shrink mr-2" contain src="/img/icons/icon-512x512.png" transition="scale-transition" width="100" />
              </v-col>
              <v-col cols="6">
                <v-img alt="UM Logo" class="shrink mr-2" contain src="/img/um.jpeg" transition="scale-transition" width="100" />
              </v-col>
            </v-row>
          </v-card>
          <v-spacer></v-spacer>

      </v-app-bar>

          <!-- <v-btn icon @click.native="toggleDarkMode"><v-icon>{{ darkMode ? "mdi-weather-night" : "mdi-weather-sunny" }}</v-icon></v-btn> -->
      <v-container>

            <v-row dense>
              <v-col
                v-for="(item, i) in items"
                :key="i"
                cols="12"
              >
                <template v-if="item.type">

                  <v-card
                    color="primary"
                    dark
                    class="mb-2 text-center"
                    :to="item.to"
                  >
                        <v-card-title
                          class="title mb-2 font-weight-bold text-center"
                        >{{ item.title }} <v-icon right>mdi-chevron-right</v-icon></v-card-title>

                  </v-card>

                </template>
                <template v-else>

                  <v-card
                    color="secondary darken-1"
                    dark
                    class="mb-2"
                    :to="item.to"
                  >
                    <div class="d-flex flex-no-wrap justify-space-between">
                      <div>
                        <v-card-title
                          class="display-1 mb-2 font-weight-bold"
                          v-text="item.title"
                        ></v-card-title>
                        <v-card-subtitle class="body-2" v-text="item.artist"></v-card-subtitle>
                      </div>

                      <v-avatar
                        class="ma-4"
                        size="80"
                        tile
                      >
                        <v-icon x-large>{{ item.icon }}</v-icon>
                      </v-avatar>
                    </div>
                  </v-card>

                </template>
                
              </v-col>
            </v-row>

      </v-container>

      <v-dialog fullscreen v-model="aboutDialog">
        <About />
      </v-dialog>

</div>

</template>

<script>
import About from '@/components/About'
export default {
  name: 'Home',
  components: {
    About
  },
  created: async function () {
    // this.darkMode = await localStorage.getItem('darkMode')
    // this.$vuetify.theme.dark = this.darkMode
  },
  data: () => ({
    aboutDialog: false,
    // darkMode: false,
    items: [

      {
        color: 'purple accent-2',
        src: '/img/icons/icon-512x512.png',
        icon: 'mdi-information-outline',
        title: 'About Lexicon Syariah',
        artist: 'Temukan lebih dari 100 istilah ekonomi syariah dalam Kamus',
        to: '/about',
        type: 'small',
      },
      {
        color: 'purple accent-2',
        src: '/img/icons/icon-512x512.png',
        icon: 'mdi-book-open-outline',
        title: 'Kamus',
        artist: 'Temukan lebih dari 100 istilah ekonomi syariah dalam Kamus',
        to: '/kamus'
      },
      {
        color: 'pink accent-2',
        src: '/img/icons/icon-512x512.png',
        icon: 'mdi-folder-outline',
        title: 'Jurnal',
        artist: 'Telusuri jurnal-jurnal ekonomi yang selalu terupdate',
        to: '/jurnal'
      }
    ]
  }),

  methods: {
    // toggleDarkMode: async function () {
    //   this.darkMode = !this.darkMode
    //   await localStorage.setItem('darkMode', this.darkMode)
    //   this.$vuetify.theme.dark = this.darkMode
    // },

    openAbout: function () {
      this.aboutDialog = true
    },
    closeAbout: function () {
      this.aboutDialog = false
    }
  }

}
</script>
